import React from "react";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import DialogTitle from "@mui/joy/DialogTitle";
import IconButton from "@mui/joy/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const { REACT_APP_IMAGE_URL } = process.env;

const handleDownload = async (image) => {
  if (!image) return;

  try {
    const imageUrl = `${REACT_APP_IMAGE_URL}${image}`;

    const response = await fetch(imageUrl);
    const blob = await response.blob();

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = image.split("/").pop() || "image";

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Download failed:", error);
  }
};

const ImagePreviewModal = ({ open, setOpen, image }) => {
  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <ModalDialog
        sx={{
          maxWidth: "600px",
          width: "90%",
          p: 2,
          borderRadius: "10px",
        }}
      >
        <div className="d-flex justify-content-between align-items-center">
          <DialogTitle onClick={()=>handleDownload(image)} sx={{ cursor: "pointer" }}>
            Download <i className="bi bi-download"></i>
          </DialogTitle>
          <IconButton onClick={() => setOpen(false)}>
            <CloseIcon />
          </IconButton>
        </div>

        <div className="text-center mt-2">
          {image ? (
            <img
              src={`${REACT_APP_IMAGE_URL}${image}`}
              alt="proof"
              style={{
                width: "100%",
                maxHeight: "400px",
                objectFit: "contain",
                borderRadius: "8px",
              }}
            />
          ) : (
            <p>No Image Available</p>
          )}
        </div>
      </ModalDialog>
    </Modal>
  );
};

export default ImagePreviewModal;
